import { createAsyncThunk } from '@reduxjs/toolkit';
import VDKEventAPI from '@infrastructure/VDK-event-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const createVDKEventAsync = createAsyncThunk('VDKEvent/create', async (event, { rejectWithValue }) => {
    try {
        const response = await VDKEventAPI.createVDKEvent(event);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateVDKEventAsync = createAsyncThunk('VDKEvent/update', async (event, { rejectWithValue }) => {
    try {
        const response = await VDKEventAPI.updateVDKEvent(event);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllVDKEventsAsync = createAsyncThunk('VDKEvent/getAll', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventAPI.getAllVDKEvents(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllVDKEventsForTaskAsync = createAsyncThunk('VDKEvent/getAllTasks', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventAPI.getAllVDKEventsForTask();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getVDKEventByIdAsync = createAsyncThunk('VDKEvent/getVDKEventById', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await VDKEventAPI.getVDKEventById(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteVDKEventAsync = createAsyncThunk('VDKEvent/delete', async (eventId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await VDKEventAPI.deleteVDKEvent(eventId);
        ;
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getVDKEventByIdForEventDetailsAsync = createAsyncThunk('VDKEvent/getVDKEventByIdForEventDetails', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await VDKEventAPI.getVDKEventByIdForEventDetails(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const validateEventPasswordAsync = createAsyncThunk('VDKEvent/validateEventPassword', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await VDKEventAPI.validateEventPassword(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllVDKEventSortAndFilterAsync = createAsyncThunk('VDKEvent/getAllVDKEventSortAndFilter', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventAPI.getAllVDKEventSortAndFilter(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateVDKEventLinkAndPasswordAsync = createAsyncThunk('VDKEvent/updateEventLinkAndPassword', async (event, { rejectWithValue }) => {
    try {
        const response = await VDKEventAPI.updateEventLinkAndPassword(event);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getVDKEventByIdForRegistrationAsync = createAsyncThunk('VDKEvent/getVDKEventByIdForRegistration', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await VDKEventAPI.getVDKEventByIdForRegistration(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPartnerEventsAsync = createAsyncThunk('VDKEvent/getPartnerVDKEvent', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await VDKEventAPI.getPartnerVDKEvents(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const LinkVDKEventAsync = createAsyncThunk('VDKEvent/link-event', async (eventId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await VDKEventAPI.LinkVDKEvent(eventId);
        ;
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getVDKEventUserCountryAsync = createAsyncThunk('VDKEvent/getUserCountry', async (_, { rejectWithValue }) => {
    try {
        const response = await VDKEventAPI.getUserCountry();
        return response.data?.countryCode ?? null;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
// export const updateVDKEventAsync = createAsyncThunk<
//   VDKEventDto,
//   UpdateVDKEventRequest,
//   { rejectValue: ApiError | undefined }
// >('VDKEvent/update', async (event, { rejectWithValue }) => {
//   try {
//     const response = await VDKEventAPI.updateVDKEvent(event);
//     return response.data;
//   } catch (error) {
//     return rejectWithValue(getErrorPayload(error));
//   }
// });
